var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['letter-avatar', _vm.extraClass]},[_vm._v(" "+_vm._s(_vm.getInitials)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }